'use client'

import AppendRoot from '@component/appendRoot'
import FullPopup from '@component/fullPopup'
import useGallery from '@hooks/useGallery'
import HouseGalleryContent from './conent'

export default function HouseGallery() {

  const { show } = useGallery()

  return (
    <AppendRoot>
      <FullPopup show={show} contentClassName='inset-0 bg-white'>
        {
          show && (
            <HouseGalleryContent></HouseGalleryContent>
          )
        }
      </FullPopup>
    </AppendRoot>
  )
}
